import type { ReactNode } from 'react';

import type { BaseComponentProps } from '../base-component.types';

export enum DifficultyLevel {
  EASY = 'easy',
  MEDIUM = 'medium',
  HARD = 'hard',
}

export type AuditLogType = {
  icon: ReactNode;
  title: string;
  description?: string;
  date: Date;
};

export type QuestionType = {
  id: string;
  text: string;
  subject?: string;
  caption?: string;
  imageUrl?: string;
  bookmarked?: boolean;
  flagged?: boolean;
  tags?: string[];
  difficulty?: DifficultyLevel;
  auditLog?: AuditLogType[];
};

export type QuestionAnswerType = {
  id: string;
  answerIndex: number;
  flagged?: boolean;
  timeInSeconds?: number;
};

/** What every screen showing a single question carries, however it shows it. */
export type QuestionScreenProps = BaseComponentProps & {
  onBookmark?: (id: string) => Promise<void>;
  onUnbookmark?: (id: string) => Promise<void>;
  onClose?: () => void;
};

export type QuestionProps = QuestionScreenProps & {
  timeInSeconds?: number;
  isSubmitting?: boolean;
  onSubmit: (answer: QuestionAnswerType) => void;
};

export type InstructionsType = {
  text: string;
  imageUrl?: string;
};
